<ng-container>
    <tg-input-container
        id="{{ containerId }}"
        class="date__date-input"
        [class.hide-optional-label]="hideOptionalLabel"
        [ngClass]="{ 'o-input--invalid': hasError }"
        [label]="label"
        [showLabel]="showLabel"
    >
        <input
            id="{{ id }}"
            name="{{ name }}"
            matInput
            tgTextInput
            [required]="getRequired()"
            [readonly]="inputReadonly"
            [disabled]="disabled"
            [(ngModel)]="selectedDate"
            [matDatepicker]="tmDatePicker"
            (dateChange)="onDateChange()"
            (focus)="tmDatePicker.open()"
            (click)="tmDatePicker.open()"
            [min]="minDate"
            [max]="maxDate"
            [validation]="getValidation()"
            placeholder="DD/MM/YYYY"
        />
        <mat-datepicker-toggle matSuffix [for]="tmDatePicker">
        </mat-datepicker-toggle>
        <mat-datepicker #tmDatePicker> </mat-datepicker>
    </tg-input-container>
</ng-container>
